export default __webpack_public_path__ + "static/media/infantBlack.d0641c7a.svg";